export default "__VITE_ASSET__B2YH9TA1__"